module.exports = __webpack_public_path__ + "media/src/assets/images/property_photo1-a9003a40a9e08444dd26bd7d1a84d32e.jpg";